import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Button from '@Atoms/Button';
import FeatureFlagGuard from '@components/Atoms/FeatureFlagGuard';
import { FEATURE_SHOW_CALENDAR } from '@components/Atoms/FeatureFlagGuard/constants';
import { InteractionContextProvider } from '@components/ElementAnalytics/InteractionContext';
import history from '../../utils/history';
import { ROLE_TYPE } from '../../utils/enums';
import Card from '../common/card/Card';
import { ScheduleWidgetWrap, CardListWrap, CardWrapper, CardText, ScheduleButtonWrap } from '../common/card/Card.style';
import { DashboardTitle, CardsWithTitle, NumberIcon, ExamNumberIcon, AssignmentCarouselsWrap } from './DashboardSummary.style';
import { padCarouselSessions, sortSessionsByDateDesc } from './carouselSessions';
import { getExamStartPath, splitExamSessions } from './filterExamSessions';

export default class DashboardUpNextWidget extends Component {
  scheduleDate = new Date();

  componentDidMount() {
    const { sectionId, sectionScheduleGet, sectionReviewSummary, userRole, sectionsExamsScoresGet, curriculumDetail } = this.props;

    if (sectionId) {
      sectionScheduleGet(sectionId);
    }
    if (userRole === ROLE_TYPE.INSTRUCTOR) {
      sectionReviewSummary(sectionId);
      if (curriculumDetail.has_exam) {
        sectionsExamsScoresGet(sectionId);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { sectionId, sectionScheduleGet, sectionReviewSummary, userRole, sectionsExamsScoresGet, curriculumDetail } = this.props;
    const { sectionId: prevSectionId } = prevProps;

    if (sectionId && sectionId !== prevSectionId) {
      sectionScheduleGet(sectionId);
      if (userRole === ROLE_TYPE.INSTRUCTOR) {
        sectionReviewSummary(sectionId);
        if (curriculumDetail.has_exam) {
          sectionsExamsScoresGet(sectionId);
        }
      }
    }
  }

  filterReviewSession = () => {
    const { sessionList, totalReviews = [] } = this.props;
    const completedReviewSessions = [];
    const inCompleteReviewSessions = [];
    let completedReviewIds = [];
    const allReviewSession = sessionList.filter((session) => {
      if (session.type === 'reviews') {
        return true;
      }
      return false;
    });

    if (totalReviews.length > 0) {
      const completedReviews = totalReviews.filter((review) => {
        if (review.count === review.completed) {
          return true;
        }
        return false;
      });
      completedReviewIds = completedReviews.map(({ id }) => id);
    }

    allReviewSession.forEach((review) => {
      if (completedReviewIds.includes(review.id)) {
        completedReviewSessions.push(review);
      } else {
        inCompleteReviewSessions.push(review);
      }
    });

    return { completedReviewSessions, inCompleteReviewSessions };
  };

  filterPracticeSession = () => {
    const { allPracticeSession, completedPracticeUnitIds } = this.props;
    const completedPracticeSessions = [];
    const incompletePracticeSessions = [];

    allPracticeSession.forEach((practice) => {
      if (completedPracticeUnitIds.includes(practice.unit)) {
        completedPracticeSessions.push(practice);
      } else {
        incompletePracticeSessions.push(practice);
      }
    });

    return { completedPracticeSessions, incompletePracticeSessions };
  };

  filterExamSession = () => {
    const { examList, examsScore, completedExamKeys, notStartedExamKeys, learnosityExamsReady } = this.props;
    if (learnosityExamsReady === false) {
      return { completedExamSessions: [], incompleteExamSessions: [] };
    }
    return splitExamSessions(examList, examsScore, completedExamKeys, notStartedExamKeys);
  };

  renderCompletedSession = (sessionList) => {
    let completedSession = [];
    let recentTwoSessions = [{ empty: true }, { empty: true }];

    sessionList.forEach((session) => {
      if (session.lesson) {
        if (session.completed !== null) {
          completedSession = [...completedSession, session];
        }
      }
    });

    const { completedReviewSessions } = this.filterReviewSession();
    if (completedReviewSessions.length > 0) {
      completedReviewSessions.forEach((review) => {
        completedSession = [...completedSession, review];
      });
    }

    const { completedExamSessions } = this.filterExamSession();
    if (completedExamSessions.length > 0) {
      completedExamSessions.forEach((exam) => {
        completedSession = [...completedSession, exam];
      });
    }

    const { completedPracticeSessions } = this.filterPracticeSession();
    if (completedPracticeSessions.length > 0) {
      completedPracticeSessions.forEach((practice) => {
        completedSession = [...completedSession, practice];
      });
    }
    if (completedSession.length > 0) {
      let sortedSession = completedSession.sort((a, b) => moment(b.date).diff(moment(a.date)));
      sortedSession = sortedSession.sort((a, b) => {
        if (moment(a.date).isSame(moment(b.date))) {
          if (a.id > b.id) {
            return -1;
          }
        }
        return 0;
      });
      recentTwoSessions = [sortedSession[1], sortedSession[0]];
    }

    return recentTwoSessions.map((session, index) => <Card key={index} session={session} status="complete" {...this.props} />);
  };

  findItemNested = (arr, itemId, nestingKey) =>
    arr.reduce((a, item) => {
      if (a) {
        return a;
      }
      if (item.id === itemId) {
        return item;
      }
      if (item[nestingKey]) {
        return this.findItemNested(item[nestingKey], itemId, nestingKey);
      }
      return null;
    }, null);

  getAssignmentSession = (assignment) => {
    const { unitBySubject } = this.props;
    const { subject, unit: unitId, lesson_group: lessonGroup, last_assigned: lastAssigned } = assignment;
    const activityType = lessonGroup ? 0 : 1;
    const { units } = unitBySubject[subject];
    const unit = this.findItemNested(units, unitId, 'children');
    const lessonName = unit?.lessons?.find((lesson) => lesson.id === lessonGroup)?.name;
    const name = lessonName || unit?.name || '';
    return {
      ...assignment,
      type: 'lessons',
      lesson: lessonGroup,
      activityType,
      name,
      date: lastAssigned,
    };
  };

  getAssignmentSessions = () => {
    const { assignList, unitBySubject } = this.props;
    return sortSessionsByDateDesc(
      (assignList?.incomplete || [])
        .filter((assignment) => unitBySubject?.[assignment.subject])
        .map((assignment) => this.getAssignmentSession(assignment)),
    );
  };

  renderCarouselCards = (sessions, { emptyMessage, isExamCarousel } = {}) =>
    padCarouselSessions(sessions).map((session, index) => (
      <Card
        key={index}
        center={index === 0}
        session={session}
        {...this.props}
        emptyMessage={emptyMessage}
        isExamCarousel={isExamCarousel}
      />
    ));

  renderInCompletedSession = (sessionList) => {
    let incompleteSession = [];
    let upcomingSession = [{ empty: true }, { empty: true }, { empty: true }];

    sessionList.forEach((session) => {
      if (session.lesson) {
        if (session.completed === null) {
          incompleteSession = [...incompleteSession, session];
        }
      }
    });

    const { inCompleteReviewSessions } = this.filterReviewSession();
    if (inCompleteReviewSessions.length > 0) {
      inCompleteReviewSessions.forEach((review) => {
        incompleteSession = [...incompleteSession, review];
      });
    }

    const { incompleteExamSessions } = this.filterExamSession();
    if (incompleteExamSessions.length > 0) {
      incompleteExamSessions.forEach((exam) => {
        incompleteSession = [...incompleteSession, exam];
      });
    }

    const { incompletePracticeSessions } = this.filterPracticeSession();
    if (incompletePracticeSessions.length > 0) {
      incompletePracticeSessions.forEach((practice) => {
        incompleteSession = [...incompleteSession, practice];
      });
    }
    if (incompleteSession.length > 0) {
      let sortedSession = incompleteSession.sort((a, b) => moment(a.date).diff(moment(b.date)));
      sortedSession = sortedSession.sort((a, b) => {
        if (moment(a.date).isSame(moment(b.date))) {
          if (a.id < b.id) {
            return -1;
          }
        }
        return 0;
      });
      upcomingSession = [sortedSession[0], sortedSession[1], sortedSession[2]];
      this.scheduleDate = upcomingSession[0]?.date || new Date();
    }

    return upcomingSession.map((session, index) => <Card key={index} center={index === 0} session={session} {...this.props} />);
  };

  renderEmptySessionList = () => {
    const { courseItem, sectionId, isAssignments } = this.props;
    const baseUrl = `/schedule/course/${courseItem.id}/section/${sectionId}`;

    return (
      <CardListWrap>
        <Card />
        <Card />
        <Link to={`${baseUrl}/section-info`}>
          <CardWrapper isAssignments={isAssignments}>
            <Card hasEmptySchedule />
            <CardText selected> {isAssignments ? 'Start Practice' : 'Up Next'}</CardText>
          </CardWrapper>
        </Link>
        <Card />
        <Card />
      </CardListWrap>
    );
  };

  handleGoToCalendar = () => {
    const { courseItem, sectionId } = this.props;
    const calendarUrl = `/schedule/course/${courseItem.id}/section/${sectionId}`;
    return history.push({ pathname: calendarUrl, state: { date: this.scheduleDate } });
  };

  handleGoToAssignments = () => {
    const { courseItem, sectionId, assignList } = this.props;
    const upcomingSession = this.getAssignmentSessions()[0];
    const incompleteAssignments = assignList?.incomplete || [];

    if (upcomingSession) {
      const { subject, unit, lesson, activityType } = upcomingSession;
      const assignmentsUrl =
        activityType === 0
          ? `/lessons/course/${courseItem.id}/section/${sectionId}/subject/${subject}/unit/${unit}/lesson/${lesson}`
          : `/lessons/course/${courseItem.id}/section/${sectionId}/subject/${subject}/unit/${unit}/practice`;
      return history.push({
        pathname: assignmentsUrl,
        state: { assignments: incompleteAssignments.length },
      });
    }
    return history.push(`/lessons/course/${courseItem.id}/section/${sectionId}`);
  };

  handleGoToExams = () => {
    const { courseItem, sectionId, testletIdByExamKey } = this.props;
    const exam = this.filterExamSession().incompleteExamSessions[0];
    if (!exam) {
      return undefined;
    }
    return history.push(
      getExamStartPath({
        courseId: courseItem.id,
        sectionId,
        examId: exam.exam_id,
        examSectionId: exam.id,
        testletIdByExamKey,
      }),
    );
  };

  renderLoadingRow = () => {
    const { isGetting: loading } = this.props;
    return (
      <ScheduleWidgetWrap>
        <CardListWrap>
          {Array(5)
            .fill()
            .map((item, index) => (
              <Card key={index} index={index} loading={loading} />
            ))}
        </CardListWrap>
      </ScheduleWidgetWrap>
    );
  };

  renderStudentCarousel = ({
    title,
    count,
    sessions,
    buttonLabel,
    onButtonClick,
    dataTestId,
    interactionArea,
    emptyMessage,
    isExamCarousel = false,
  }) => (
    <InteractionContextProvider interactionArea={interactionArea}>
      <CardsWithTitle complete={!count}>
        <DashboardTitle>
          {isExamCarousel ? (
            <ExamNumberIcon>
              <span>{count}</span>
            </ExamNumberIcon>
          ) : (
            <NumberIcon>
              <span>{count}</span>
            </NumberIcon>
          )}
          <p>{title}</p>
        </DashboardTitle>
        <ScheduleWidgetWrap>
          <CardListWrap>{this.renderCarouselCards(sessions, { emptyMessage, isExamCarousel })}</CardListWrap>
          <ScheduleButtonWrap grey={!count}>
            <Button isDisable={!count} disabled={!count} onClick={onButtonClick} dataTestId={dataTestId}>
              {buttonLabel}
            </Button>
          </ScheduleButtonWrap>
        </ScheduleWidgetWrap>
      </CardsWithTitle>
    </InteractionContextProvider>
  );

  renderAssignmentCarousels = () => {
    const assignmentSessions = this.getAssignmentSessions();
    const { incompleteExamSessions } = this.filterExamSession();

    return (
      <AssignmentCarouselsWrap>
        {this.renderStudentCarousel({
          title: 'Assignments',
          count: assignmentSessions.length,
          sessions: assignmentSessions,
          buttonLabel: 'Go to Assignments',
          onButtonClick: this.handleGoToAssignments,
          dataTestId: 'assignments',
          interactionArea: 'assignments',
          emptyMessage: 'You have no assignments right now.',
        })}
        {this.renderStudentCarousel({
          title: 'Exams',
          count: incompleteExamSessions.length,
          sessions: incompleteExamSessions,
          buttonLabel: 'Go to Tests',
          onButtonClick: this.handleGoToExams,
          dataTestId: 'exams',
          interactionArea: 'exams',
          isExamCarousel: true,
          emptyMessage: 'You have no exams right now.',
        })}
      </AssignmentCarouselsWrap>
    );
  };

  render() {
    const { isGetting: loading, sessionList, isAssignments, userRole } = this.props;

    if (loading) {
      if (isAssignments) {
        return (
          <AssignmentCarouselsWrap>
            {this.renderLoadingRow()}
            {this.renderLoadingRow()}
          </AssignmentCarouselsWrap>
        );
      }
      return this.renderLoadingRow();
    }
    if (isAssignments) {
      return this.renderAssignmentCarousels();
    }
    if (sessionList.length === 0) {
      return this.renderEmptySessionList();
    }

    return (
      <InteractionContextProvider interactionArea="up-next">
        <CardsWithTitle>
          {userRole === ROLE_TYPE.STUDENT && (
            <DashboardTitle>
              <p>Lessons</p>
            </DashboardTitle>
          )}
          <ScheduleWidgetWrap>
            <CardListWrap>
              {this.renderCompletedSession(sessionList)}
              {this.renderInCompletedSession(sessionList)}
            </CardListWrap>
            <ScheduleButtonWrap>
              <FeatureFlagGuard featureName={FEATURE_SHOW_CALENDAR}>
                <Button onClick={this.handleGoToCalendar} dataTestId="calendar">
                  Go to Calendar
                </Button>
              </FeatureFlagGuard>
            </ScheduleButtonWrap>
          </ScheduleWidgetWrap>
        </CardsWithTitle>
      </InteractionContextProvider>
    );
  }
}
